// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState, useRef } from 'react';
import TopBar from '../../../Components/TopBar';
import { useReactToPrint } from 'react-to-print';
import { Helmet } from 'react-helmet';
import { pageView, customEvent } from '../../../Utilities/GoogleAnalytics';
import { Link } from 'react-router-dom';

export default function Timeline() {
  const [visaType, changeVisaType] = useState('');
  const [instituteType, changeInstituteType] = useState('');

  const [ielts, setIELTS] = useState(false);
  const [gre, setGRE] = useState(false);

  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [intakes, setIntakes] = useState([]);
  const [fees, setFees] = useState(0);
  const [selectedIntake] = useState({});
  const [currency, setCurrency] = useState('CAD');
  const [printMode, setPrintMode] = useState(false);
  const [totalMoneyCost, setTotalMoneyCost] = useState(0);

  const FullLogo = 'https://res.cloudinary.com/stamped/image/upload/v1608735103/General%20Assets/stampedFull_d9ryj4.png';

  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const defaultTimeline = useMemo(
    () => [
      {
        name: 'Today',
        timeCost: 0,
        moneyCost: 0,
        show: true,
      },
      {
        category: 'IELTS',
        name: 'Book IELTS & IELTS Preparation Start',
        timeCost: 0,
        moneyCost: 230,
        show: false,
      },
      {
        category: 'GRE',
        name: 'Book GRE & GRE Preparation Start',
        timeCost: 0,
        moneyCost: 275,
        show: false,
      },
      {
        category: 'GRE',
        name: 'GRE Exam',
        timeCost: 30,
        moneyCost: 0,
        show: false,
      },
      {
        category: 'GRE',
        name: 'GRE Result',
        timeCost: 10,
        moneyCost: 0,
        show: false,
      },
      {
        category: 'IELTS',
        name: 'IELTS Exam',
        timeCost: 14,
        moneyCost: 0,
        show: false,
      },
      {
        category: 'IELTS',
        name: 'IELTS Result & Physical Copy',
        timeCost: 14,
        moneyCost: 0,
        show: false,
      },
      {
        category: 'INSTITUTE',
        name: 'Submit College Application',
        timeCost: 0,
        moneyCost: 100,
        show: false,
      },
      {
        category: 'INSTITUTE',
        name: 'College Acceptance Received',
        timeCost: 30,
        moneyCost: 0,
        show: false,
      },
      {
        category: 'INSTITUTE',
        name: 'Pay Fees & Pay GIC',
        timeCost: 1,
        moneyCost: 10200,
        show: false,
      },
      {
        category: 'INSTITUTE',
        name: 'Medical Test / Same Day Acknowledgement',
        timeCost: 2,
        moneyCost: 100,
        show: false,
      },
      {
        category: 'INSTITUTE',
        name: 'Fees Confirmation & Receipt',
        timeCost: 5,
        moneyCost: 0,
        show: false,
      },
      {
        category: 'INSTITUTE',
        name: 'GIC Certificate Received',
        timeCost: 0,
        moneyCost: 0,
        show: false,
      },
      {
        category: 'VISA',
        name: 'Visa Application',
        timeCost: 0,
        moneyCost: 225,
        show: false,
      },
      {
        category: 'VISA',
        name: 'Biometric Letter From IRCC',
        timeCost: 1,
        moneyCost: 0,
        show: false,
      },
      {
        category: 'VISA',
        name: 'Biometric Submission',
        timeCost: 5,
        moneyCost: 0,
        show: false,
      },
      {
        category: 'VISA',
        name: 'Visa Result',
        timeCost: 28,
        moneyCost: 0,
        show: false,
      },
    ],
    []
  );

  const [timeline, changeTimeline] = useState([]);

  function addDays(dateObj, numDays) {
    dateObj.setDate(dateObj.getDate() + numDays);
    return dateObj;
  }

  function formatDateForStamped(newDate) {
    var dd = newDate.getDate();
    var mm = months[newDate.getMonth()];
    var y = newDate.getFullYear();
    var formattedDate = dd + ' ' + mm + ' ' + y;
    return formattedDate;
  }

  // @ts-ignore
  function visaTypeSelected(visa) {
    changeVisaType(visa);
    if (visa === 'SDS') {
      customEvent('Visa Type', 'SDS');
      for (var i = 0; i < defaultTimeline.length; i++) {
        if (defaultTimeline[i].name === 'Visa Result') {
          defaultTimeline[i].timeCost = 30;
        }
        if (defaultTimeline[i].category === 'VISA') {
          defaultTimeline[i].show = true;
        }
      }
      regenCost();
    } else if (visa === 'NSDS') {
      customEvent('Visa Type', 'Non SDS');
      for (i = 0; i < defaultTimeline.length; i++) {
        if (defaultTimeline[i].name === 'Visa Result') {
          defaultTimeline[i].timeCost = 60;
        }
        if (defaultTimeline[i].category === 'VISA') {
          defaultTimeline[i].show = true;
        }
      }
      regenCost();
    }
  }

  function instituteTypeSelected(institute) {
    changeInstituteType(institute);
    if (institute === 'UNI') {
      customEvent('Institute Selected', 'UNIVERSITY');
      for (var i = 0; i < defaultTimeline.length; i++) {
        if (defaultTimeline[i].name === 'College Acceptance Received') {
          defaultTimeline[i].timeCost = 90;
        }
        if (defaultTimeline[i].category === 'INSTITUTE') {
          defaultTimeline[i].show = true;
        }
      }
      regenCost();
    } else if (institute === 'COL') {
      customEvent('Institute Selected', 'COLLEGE');
      for (i = 0; i < defaultTimeline.length; i++) {
        if (defaultTimeline[i].name === 'College Acceptance Received') {
          defaultTimeline[i].timeCost = 30;
        }
        if (defaultTimeline[i].category === 'INSTITUTE') {
          defaultTimeline[i].show = true;
        }
      }
      regenCost();
    }
  }

  function ieltsSelected() {
    setIELTS(!ielts);
    for (var i = 0; i < defaultTimeline.length; i++) {
      if (defaultTimeline[i].category === 'IELTS') {
        if (ielts) {
          defaultTimeline[i].show = false;
        } else {
          defaultTimeline[i].show = true;
        }
      }
    }
    regenCost();
  }

  function greSelected() {
    setGRE(!gre);
    for (var i = 0; i < defaultTimeline.length; i++) {
      if (defaultTimeline[i].category === 'GRE') {
        if (gre) {
          defaultTimeline[i].show = false;
        } else {
          defaultTimeline[i].show = true;
        }
      }
    }
    regenCost();
  }

  // runs everytime timeline is changed?
  useEffect(() => {
    var tmc = 0;
    for (var i = 0; i < defaultTimeline.length; i++) {
      if (defaultTimeline[i].show) {
        tmc = tmc + defaultTimeline[i].moneyCost;
      }
    }
    setTotalMoneyCost(tmc + parseInt(fees));
  }, [ielts, gre, instituteType, visaType, timeline, fees]);

  // generates cumalative costs
  function regenCost() {
    // lets calculate total money cost
    for (var i = 0; i < defaultTimeline.length; i++) {
      defaultTimeline[i].priority = i;
      if (defaultTimeline[i].show) {
        // calculating cumalative time
        const prevTimeCost = defaultTimeline[i - 1] ? defaultTimeline[i - 1].cumalativeCost : 0;
        const currentTimeCost = defaultTimeline[i].timeCost;
        const totalTimeCost = prevTimeCost + currentTimeCost;
        defaultTimeline[i].cumalativeCost = totalTimeCost;

        // calculating total money
        const prevMoneyCost = defaultTimeline[i - 1] ? defaultTimeline[i - 1].moneyCost : 0;
        const currentMoneyCost = defaultTimeline[i].moneyCost;
        const totalMoneyCost = prevMoneyCost + currentMoneyCost;
        defaultTimeline[i].totalMoneyCost = totalMoneyCost;
      } else {
        const prevTimeCost = defaultTimeline[i - 1] ? defaultTimeline[i - 1].cumalativeCost : 0;
        const currentTimeCost = 0;
        const totalTimeCost = prevTimeCost + currentTimeCost;
        defaultTimeline[i].cumalativeCost = totalTimeCost;

        // calculating cumaltive money
        const prevMoneyCost = defaultTimeline[i - 1] ? defaultTimeline[i - 1].moneyCost : 0;
        const currentMoneyCost = 0;
        const totalMoneyCost = prevMoneyCost + currentMoneyCost;
        defaultTimeline[i].totalMoneyCost = totalMoneyCost;
      }
    }
    var lastIndex = defaultTimeline.length - 1;
    setCurrentMonth(addDays(new Date(), defaultTimeline[lastIndex].cumalativeCost).getMonth());
    setCurrentYear(addDays(new Date(), defaultTimeline[lastIndex].cumalativeCost).getFullYear());
  }

  /**
   * A call to action element for the screen for Mobile
   */
  const MobileFollowCTA = () => {
    return (
      <div className="fixed z-50 w-full h-auto">
        <div className="px-4 py-1 bg-brandcolor">
          <p className="text-xs font-bold text-center text-white capitalize">
            You don't need an agent –{' '}
            <Link to="/">
              {' '}
              <span className="transition duration-100 border-b-2"> See Why </span> {' '}
            </Link>
          </p>
        </div>
      </div>
    );
  };

  useEffect(() => {
    regenCost();
    changeTimeline(defaultTimeline);
  }, [defaultTimeline, timeline]);

  const comment1 = 'Could target this one!';
  const comment2 = "There's enough time here";
  const comment3 = 'More than enough time';

  useEffect(() => {
    if (currentMonth > -1 && currentMonth < 4) {
      setIntakes([
        {
          month: 'May',
          year: currentYear,
          comment: comment1,
        },
        {
          month: 'Sept',
          year: currentYear,
          comment: comment2,
        },
        {
          month: 'Jan',
          year: currentYear + 1,
          comment: comment3,
        },
      ]);
    } else if (currentMonth > 3 && currentMonth < 8) {
      setIntakes([
        {
          month: 'Sept',
          year: currentYear,
          comment: comment1,
        },
        {
          month: 'Jan',
          year: currentYear + 1,
          comment: comment2,
        },
        {
          month: 'May',
          year: currentYear + 1,
          comment: comment3,
        },
      ]);
    } else if (currentMonth > 7 && currentMonth < 12) {
      setIntakes([
        {
          month: 'Jan',
          year: currentYear + 1,
          comment: comment1,
        },
        {
          month: 'May',
          year: currentYear + 1,
          comment: comment2,
        },
        {
          month: 'Sept',
          year: currentYear + 1,
          comment: comment3,
        },
      ]);
    }
  }, [currentMonth, currentYear]);

  const printRef = useRef();

  const startPrinting = () => {
    setPrintMode(true);
    handlePrint();
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: 'Stamped Official Timeline & Budget Generator (stamped.wiki)',
    onAfterPrint: () => setPrintMode(false),
    removeAfterPrint: true,
  });

  //On load, let us punch some pageview
  useEffect(() => {
    pageView(window.location.pathname);
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Stamped – Timeline & Budget Generator | All In One Digital Bundle</title>
        <link rel="canonical" href="https://stamped.wiki/tools/timeline" />
        <meta property="og:site_name" content="Stamped Canada - Products for Students" />
        <meta property="og:title" content="Stamped – Timeline & Budget Generator" />
        <meta
          property="og:description"
          content="Stamped's Budget & Timeline generator helps students visualize and plan their journey to Canada. Get an estimate of all the costs sorted by priority.
"
        />
        <meta
          property="og:image"
          itemprop="image"
          content="https://res.cloudinary.com/dvox8u7xp/image/upload/v1607509775/T/stamped-graph-image_wcxbeb.png"
        />
        <meta property="og:type" content="website" />

        {/** Twitter Cards */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://stamped.wiki/tools/timeline/" />
        <meta property="twitter:title" content="Stamped Canada - Products for Students" />
        <meta
          property="twitter:description"
          content="Stamped's Budget & Timeline generator helps students visualize and plan their journey to Canada. Get an estimate of all the costs sorted by priority."
        />
        <meta property="twitter:image" content="https://res.cloudinary.com/dvox8u7xp/image/upload/v1607509775/T/stamped-graph-image_wcxbeb.png" />
      </Helmet>
      <TopBar />
      <div ref={printRef} className="w-full min-h-screen bg-altBack font-brand">
        <div className="w-full min-h-screen pt-32 pb-32 m-auto lg:pt-48 lg:w-5/6 bg-altBack font-brand">
          <div className="w-full pl-6 pr-6">
            <h1 className="mb-4 text-3xl font-bold leading-10 text-center text-brandcolor font-brand lg:text-5xl">Timeline & Budget Generator</h1>{' '}
            <p className="w-full m-auto text-center text-gray-700 text-md lg:w-2/3 lg:text-xl font-brand">
              Stamped's Budget & Timeline generator helps you visualize and plan your journey to Canada. Input your information to get a rough
              estimate of all the costs involved - and see these costs sorted by priority.
            </p>
            <p hidden={!printMode} className="pt-2 font-bold text-center text-brandcolor">
              https://www.stamped.wiki/tools/timeline
            </p>
            <hr className="mt-6 mb-6 text-gray-300" />
            <div className="w-full lg:flex">
              <div id={'input'} hidden={printMode} className="w-full text-center lg:text-left lg:w-1/3">
                <h1 className="pt-1 pb-1 mt-6 text-sm font-semibold uppercase"> I am yet to take </h1>
                <div className="w-full">
                  <div id="visa-type" className="flex justify-center m-auto lg:justify-start">
                    <div
                      onClick={() => {
                        ieltsSelected();
                      }}
                      className={`pt-3 pl-6 pb-3 pr-6 m-1 transition-all duration-200 ${
                        ielts ? 'bg-brandcolor text-white' : 'bg-white'
                      } rounded-sm shadow-md cursor-pointer hover:shadow-xl`}
                    >
                      <p> IELTS </p>
                    </div>
                    <div
                      onClick={() => {
                        greSelected();
                      }}
                      className={`pt-3 pl-6 pb-3 pr-6 m-1 transition-all duration-200 ${
                        gre ? 'bg-brandcolor text-white' : 'bg-white'
                      } rounded-sm shadow-md cursor-pointer hover:shadow-xl`}
                    >
                      <p> GMAT / GRE </p>
                    </div>
                  </div>
                </div>
                <br />
                <h1 className="pt-1 pb-1 mt-1 text-sm font-semibold uppercase"> Choose Institute Type </h1>
                <div id="institute-type" className="flex justify-center lg:justify-start">
                  <div
                    onClick={() => {
                      instituteTypeSelected('UNI');
                    }}
                    className={`pt-3 pl-6 pb-3 pr-6 m-1 transition-all duration-200 ${
                      instituteType === 'UNI' ? 'bg-brandcolor text-white' : 'bg-white'
                    } rounded-sm shadow-md cursor-pointer hover:shadow-xl`}
                  >
                    <p> University </p>
                  </div>
                  <div
                    onClick={() => {
                      instituteTypeSelected('COL');
                    }}
                    className={`pt-3 pl-6 pb-3 pr-6 m-1 transition-all duration-200 ${
                      instituteType === 'COL' ? 'bg-brandcolor text-white' : 'bg-white'
                    } rounded-sm shadow-md cursor-pointer hover:shadow-xl`}
                  >
                    <p> College </p>
                  </div>
                </div>
                <br />
                <h1 className="pt-1 pb-1 mt-1 text-sm font-semibold uppercase"> Choose Visa Type </h1>
                <p className="w-2/3 pt-2 pb-2 m-auto text-xs text-gray-800 lg:m-px lg:w-1/2">
                  To know in-depth about all the processes, documents required, samples, visit
                  <a className="font-semibold text-brandcolor" href="https://stamped.wiki/">
                    {' '}
                    Stamped's Official Bundle.
                  </a>
                </p>
                <div id="visa-type" className="flex justify-center lg:justify-start">
                  <div
                    onClick={() => {
                      visaTypeSelected('SDS');
                    }}
                    className={`pt-3 pl-6 pb-3 pr-6 m-1 transition-all duration-200 text-sm ${
                      visaType === 'SDS' ? 'bg-brandcolor text-white' : 'bg-white'
                    } rounded-sm shadow-md cursor-pointer hover:shadow-xl`}
                  >
                    <p> SDS Visa </p>
                  </div>
                  <div
                    onClick={() => {
                      visaTypeSelected('NSDS');
                    }}
                    className={`pt-3 pl-6 pb-3 pr-6 m-1 transition-all duration-200 ${
                      visaType === 'NSDS' ? 'bg-brandcolor text-white' : 'bg-white'
                    } rounded-sm shadow-md cursor-pointer hover:shadow-xl`}
                  >
                    <p> Non SDS Visa </p>
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="w-full">
                    <h1 className="pt-5 pb-1 mt-5 text-sm font-semibold tracking-wide uppercase"> Annual Fees </h1>
                    <p className="w-2/3 pt-2 pb-2 m-auto text-xs text-gray-800 lg:m-px lg:w-1/2">
                      Incase you haven't finalised your course and college yet, you can use{' '}
                      <a className="font-semibold text-brandcolor" href="https://stamped.wiki/tools/college-finder">
                        Stamped's College Finder
                      </a>{' '}
                      to find a College / University in your preferred city or province.
                    </p>
                    <div className="flex justify-center lg:justify-start">
                      <div className="flex items-center p-2 mt-1 mb-1 ml-1 text-xs font-semibold text-white bg-red-600 shadow-md rounded-tl-md rounded-bl-md">
                        {' '}
                        CAD ($){' '}
                      </div>
                      <input
                        onChange={(e) => {
                          setFees(e.target.value === '' ? 0 : parseInt(e.target.value));
                        }}
                        type="number"
                        value={fees}
                        placeholder="20000"
                        className="p-2 pl-5 mt-1 mb-1 mr-1 transition-all duration-500 bg-white shadow-md cursor-pointer lg:w-1/3 rounded-tr-md rounded-br-md hover:shadow-xl"
                      />
                    </div>
                  </div>
                </div>

                <div className="p-6 mt-10 rounded-lg lg:w-1/2 bg-darkAlt">
                  <ul className="text-sm font-medium">
                    <p className="pt-2 pb-2 text-xs tracking-wide text-black uppercase opacity-50"> Timeline Considerations: </p>
                    <li className="">{visaType && '✅ You have selected ' + (visaType === 'SDS' ? 'SDS' : 'Non SDS Visa')} </li>
                    <li className="">
                      {instituteType === 'COL' && '✅ You have chosen to enroll in a College'}
                      {instituteType === 'UNI' && '✅ You have chosen to enroll in a University'}
                    </li>
                    <li className="">
                      {selectedIntake.month && '✅ You are aiming for ' + selectedIntake.month + ' ' + selectedIntake.year + ' intake'}{' '}
                    </li>
                    <li className=""> {fees ? '✅ Annual fees in INR: ' + fees * 55 : ''} </li>
                    <li className="">{ielts ? '✅ You are yet to take IELTS' : ''} </li>
                    <li className="">{gre ? '✅ You are yet to take GRE / GMAT' : ''} </li>
                  </ul>
                </div>
              </div>
              <div className="">
                <h1 className="pb-1 mt-6 text-sm font-semibold uppercase"> Possible Intakes </h1>
                <div id="intakes" className="flex flex-wrap m-auto">
                  {intakes.map((intake, i) => (
                    <div
                      key={intake.month}
                      className={`p-3 lg:p-6 m-1 transition-all duration-500 ${
                        i === 0 ? 'bg-green-600  text-white' : 'bg-green-800 text-white'
                        // @ts-ignore
                      } rounded-sm shadow-md cursor-pointer ${selectedIntake.month === intake.month ? 'bg-opacity-100' : 'bg-opacity-100'}`}
                    >
                      <div className="flex">
                        <p> {intake.month + ' ' + intake.year} </p>
                      </div>
                      <p className="text-xs"> {intake.comment} </p>
                    </div>
                  ))}
                </div>

                <div className="w-full mt-12 space-y-4 lg:w-full xl:w-full">
                  <table className="w-full">
                    <tbody>
                      <tr className="flex ">
                        <td className="w-full pb-4 text-xs font-bold uppercase cursor-default">Event</td>
                        <td className="w-full pb-4 text-xs font-bold uppercase cursor-default">Est. date </td>
                        <td className="w-full pb-4 text-xs font-bold uppercase cursor-default">
                          <div className="flex items-center">
                            Cost {currency === 'CAD' ? '($) CAD' : '(₹) INR'}{' '}
                            <svg
                              onClick={() => {
                                setCurrency(currency === 'CAD' ? 'INR' : 'CAD');
                              }}
                              className="w-3 h-3 ml-2 cursor-pointer"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                              ></path>
                            </svg>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody className="w-full">
                      {timeline
                        .sort(function (a, b) {
                          if (a.priority < b.priority) return -1;
                          if (a.priority > b.priority) return 1;
                          return 0;
                        })
                        .map(
                          (event, i) =>
                            event.show && (
                              <tr key={i} className="flex p-3 mt-1 bg-white rounded-lg shadow-md">
                                <td className="w-full pt-1 pb-1 pl-2 pr-2 text-sm font-semibold">{event.name}</td>
                                <td className="w-full pt-1 pb-1 pl-2 pr-2 text-sm font-semibold">
                                  {formatDateForStamped(addDays(new Date(), timeline[i] && timeline[i].cumalativeCost))}
                                </td>
                                <td className="w-full pt-2 pb-2 pl-4 pr-4 text-sm font-semibold">
                                  {currency === 'CAD' ? '$ ' + event.moneyCost : '₹ ' + event.moneyCost * 55}
                                </td>
                                {/* <p> CC: {timeline[i] && timeline[i].timeCost} </p>
                                <p> PCC: {timeline[i - 1] && timeline[i - 1].cumalativeCost} </p>
                                <p> CCC: {timeline[i] && timeline[i].cumalativeCost} </p> */}
                              </tr>
                            )
                        )}
                      <tr className="flex p-3 mt-1 rounded-lg">
                        <td className="w-full pt-1 pb-1 pl-2 pr-2 text-sm font-semibold"></td>
                        <td className="items-center w-full pt-1 pb-1 pl-2 pr-2 text-sm font-semibold text-right">Total Budget</td>
                        <td className="w-full pt-1 pb-1 pl-2 pr-2 text-sm font-semibold">
                          {currency === 'CAD' ? '$ ' + totalMoneyCost : '₹ ' + totalMoneyCost * 55}
                        </td>
                        {/* <p> CC: {timeline[i] && timeline[i].timeCost} </p>
                                <p> PCC: {timeline[i - 1] && timeline[i - 1].cumalativeCost} </p>
                                <p> CCC: {timeline[i] && timeline[i].cumalativeCost} </p> */}
                      </tr>
                    </tbody>
                  </table>
                  <p hidden={printMode} className="w-full pt-6 pb-1 text-xs font-hairline text-gray-800 normal-case">
                    1. All dates are estimated and based out of the average time it takes to complete them. Your dates and time might differ due to
                    external consequences.
                  </p>
                  <br />
                  <p hidden={printMode} className="w-full pt-1 pb-1 text-xs font-hairline text-gray-800 normal-case">
                    2.To know the exact time for Student Visa Processing, please visit{' '}
                    <a
                      className="font-semibold text-brandcolor"
                      href="https://www.canada.ca/en/immigration-refugees-citizenship/services/application/check-processing-times.html"
                    >
                      Official IRCC Time Estimation Website.
                    </a>{' '}
                  </p>
                  {
                    // shows stamped logo when the printing mode starts
                    printMode ? <img className="m-auto mt-64 text-center" width="150px" src={FullLogo} alt="Stamped Logo" /> : ''
                  }

                  {
                    // hides the print button when the printing mode starts
                    printMode ? (
                      ''
                    ) : (
                      <div className="flex w-full mt-34">
                        <div
                          onClick={() => {
                            startPrinting();
                            customEvent('User', 'Print Timeline');
                          }}
                          className={`flex items-center pt-3 pl-6 pb-3 pr-6 w-1/2 lg:w-1/4 transition-all duration-200 text-sm bg-white text-black rounded-sm shadow-md cursor-pointer hover:shadow-xl`}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="w-1/6" stroke="currentColor">
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={1}
                              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                            />
                          </svg>
                          <p className="pl-2 font-semibold">Print This Timeline</p>
                        </div>
                        <a
                          onClick={() => customEvent('User', 'Share Timeline On WhatsApp')}
                          className="flex items-center w-1/2 pt-3 pb-3 pl-6 pr-6 text-sm text-black transition-all duration-200 bg-white rounded-sm shadow-md cursor-pointer lg:w-1/4 lg:hidden hover:shadow-xl"
                          href="whatsapp://send?text=Check Stamped's New Timeline Generator. https://stamped.wiki/tools/timeline"
                          data-action="share/whatsapp/share"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 172 172">
                            <g
                              fill="none"
                              fillRule="nonzero"
                              stroke="none"
                              strokeWidth="1"
                              strokeLinecap="butt"
                              strokeLinejoin="miter"
                              strokeMiterlimit="10"
                              strokeDasharray=""
                              strokeDashoffset="0"
                              fontFamily="none"
                              fontWeight="none"
                              fontSize="none"
                              textAnchor="none"
                            >
                              <path d="M0,172v-172h172v172z" fill="none"></path>
                              <g fill="#000000">
                                <path d="M86,6.88c-43.6552,0 -79.12,35.4648 -79.12,79.12c0,14.03209 3.84829,27.12743 10.26625,38.5589l-10.13859,36.19391c-0.32961,1.17862 -0.00828,2.44361 0.84387,3.32204c0.85215,0.87843 2.1068,1.23803 3.29488,0.94436l37.73922,-9.3525c11.0895,5.92016 23.67289,9.45328 37.11437,9.45328c43.6552,0 79.12,-35.4648 79.12,-79.12c0,-43.6552 -35.4648,-79.12 -79.12,-79.12zM86,13.76c39.9368,0 72.24,32.3032 72.24,72.24c0,39.9368 -32.3032,72.24 -72.24,72.24c-12.80359,0 -24.7951,-3.33806 -35.21969,-9.1711c-0.76244,-0.42603 -1.65837,-0.54613 -2.5061,-0.33594l-33.04953,8.19016l8.86203,-31.61844c0.25624,-0.90292 0.13246,-1.87134 -0.34266,-2.68078c-6.3353,-10.74275 -9.98406,-23.24194 -9.98406,-36.6239c0,-39.9368 32.3032,-72.24 72.24,-72.24zM57.25047,44.72c-2.20517,0 -5.35447,0.82041 -7.94156,3.60797c-1.5539,1.67432 -8.0289,7.98315 -8.0289,19.07453c0,11.56363 8.01999,21.54162 8.98969,22.8236h0.00672v0.00672c-0.09199,-0.12088 1.23082,1.79472 2.99656,4.09172c1.76575,2.29699 4.2349,5.31383 7.33688,8.57984c6.20394,6.53203 14.92665,14.08115 25.75297,18.69828c4.98566,2.12306 8.91892,3.40494 11.8989,4.34031c5.52255,1.7341 10.55261,1.4705 14.3311,0.91375c2.82823,-0.4165 5.93885,-1.77449 9.01656,-3.72219c3.07772,-1.9477 6.09406,-4.36949 7.42422,-8.04906c0.9529,-2.63791 1.43732,-5.07565 1.6125,-7.08156c0.08758,-1.00296 0.09871,-1.88815 0.03359,-2.70765c-0.06526,-0.8195 0.00447,-1.44725 -0.75922,-2.70094c-1.60156,-2.62959 -3.41532,-2.69822 -5.30781,-3.63485c-1.0515,-0.52041 -4.04526,-1.9823 -7.04797,-3.41312c-2.99933,-1.42922 -5.5964,-2.69503 -7.19578,-3.26531c-1.01048,-0.36355 -2.24435,-0.8869 -4.02453,-0.68531c-1.78018,0.20158 -3.53839,1.48601 -4.56203,3.00328c-0.97027,1.43816 -4.87621,6.04872 -6.06703,7.40406c-0.01582,-0.00963 0.08751,0.03797 -0.38297,-0.19485c-1.47277,-0.72889 -3.27396,-1.34866 -5.93938,-2.75469c-2.66541,-1.40603 -5.99961,-3.48227 -9.64812,-6.6986v-0.00672c-5.43043,-4.78075 -9.23423,-10.78301 -10.43422,-12.79922c0.08084,-0.09618 -0.00961,0.0203 0.16125,-0.14781l0.00672,-0.00672c1.22641,-1.20797 2.31331,-2.65072 3.23172,-3.70875c1.30217,-1.50014 1.87683,-2.82258 2.49937,-4.05812c1.24072,-2.46244 0.54988,-5.17212 -0.16797,-6.59781v-0.00672c0.04957,0.09862 -0.38831,-0.86752 -0.86,-1.98203c-0.47303,-1.11769 -1.076,-2.5667 -1.72,-4.11188c-1.288,-3.09035 -2.72595,-6.55646 -3.58109,-8.58656v-0.00672c-1.00739,-2.39124 -2.37031,-4.11391 -4.15219,-4.945c-1.78188,-0.83109 -3.35616,-0.59481 -3.41984,-0.59797h-0.00672c-1.27158,-0.05866 -2.66694,-0.0739 -4.0514,-0.0739zM57.25047,51.6c1.32626,0 2.63379,0.01617 3.7289,0.06719c1.12658,0.05614 1.05651,0.06075 0.83985,-0.04031c-0.22013,-0.10265 0.07854,-0.13598 0.71891,1.38406c0.83733,1.98782 2.28238,5.46648 3.57437,8.56641c0.646,1.54996 1.25058,3.00458 1.73344,4.14547c0.48286,1.14089 0.74449,1.77788 1.04813,2.38515v0.00672l0.00672,0.00672c0.2977,0.58738 0.27137,0.21132 0.16797,0.41656c-0.72594,1.44077 -0.82444,1.79453 -1.55875,2.64047c-1.11807,1.28805 -2.25852,2.72447 -2.86219,3.31906c-0.52814,0.51882 -1.48109,1.32709 -2.0761,2.90922c-0.59592,1.58455 -0.31779,3.7586 0.63828,5.38172c1.27291,2.16099 5.46756,8.98838 11.98625,14.7275c4.10524,3.61896 7.92985,6.01407 10.98515,7.62578c3.05531,1.61171 5.54379,2.55301 6.10063,2.8286c1.32226,0.6544 2.76742,1.16255 4.44781,0.96078c1.68039,-0.20176 3.12916,-1.22133 4.0514,-2.26422l0.00672,-0.00672c1.2274,-1.39152 4.87455,-5.55605 6.62469,-8.12297c0.07417,0.02614 0.04988,0.00585 0.63156,0.215v0.00672h0.00672c0.26557,0.09457 3.59181,1.58337 6.5575,2.99656c2.96569,1.41319 5.97581,2.88202 6.95391,3.3661c1.41155,0.6986 2.07852,1.15339 2.25078,1.15562c0.01164,0.30267 0.02341,0.63065 -0.02016,1.12875c-0.12064,1.38163 -0.48995,3.29404 -1.22953,5.34141c-0.36231,1.00226 -2.24937,3.06941 -4.62922,4.57547c-2.37984,1.50606 -5.2765,2.56983 -6.34922,2.72781c-3.22536,0.47525 -7.05485,0.64875 -11.26063,-0.67188c-2.91618,-0.91535 -6.55236,-2.10022 -11.26062,-4.10515c-9.5488,-4.07231 -17.66452,-11.00199 -23.46188,-17.10594c-2.89867,-3.05197 -5.22106,-5.89303 -6.87328,-8.04234c-1.64914,-2.1453 -2.36926,-3.26169 -2.96969,-4.05141l-0.00672,-0.00672c-1.06581,-1.40946 -7.59219,-10.48746 -7.59219,-18.66469c0,-8.65422 4.01963,-12.04796 6.19469,-14.39156c1.14187,-1.23035 2.39024,-1.41094 2.89578,-1.41094z"></path>
                              </g>
                            </g>
                          </svg>
                          <button className="flex pl-2 font-semibold">Share Tool via Whatsapp</button>
                        </a>
                      </div>
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
